<template>
  <div class="wrap">
    <div style="height: calc(100vh - 130px); overflow: auto" class="pt-4">
      <add-visitor @childData1="getChildData" :type="`proxy`"></add-visitor>
      <div class="bottom px-6 mt-8">
        <div class="bottom_main text-medium-x inline-block font-bold mb-3">2.招募信息</div>
        <add-task ref="childTask" :type="`proxy`" :labelwidth="'140px'"></add-task>
      </div>
    </div>
    <div class="btn-footer">
      <el-button @click="$emit('cancel')" style="width: 88px">取消</el-button>
      <el-button type="primary" @click="doneClick" style="width: 88px">确认</el-button>
    </div>
  </div>
</template>

<script>
import AddVisitor from '@/components/interview/add-visitor/add-visitor'
import AddTask from '@/components/interview/add-task/add-task'
import { isNum } from '@/assets/js/utils'
import { agencyListDl, wjentrusttask, addList } from '@/api/wenjuan/publishQuestion'
import GlobalConfig from '@/global/config'

const testNum = /((^[0-9]\d*)|^0)(\.\d{0,2})?$/
export default {
  name: '',
  components: {
    AddVisitor,
    AddTask
  },
  props: {},
  data() {
    const taskNameRules = (rule, value, callback) => {
      let v = this.taskInfo.taskName
      if (!v.trim()) {
        callback(new Error('（请输入问卷标题）'))
      }
      callback()
    }
    const requireCountRules = (rule, value, callback) => {
      let v = this.taskInfo[rule.fullField]
      if (!isNum.test(v)) {
        callback(new Error('请输入有效数字'))
      }
      if (rule.fullField === 'unitPrice') {
      } else if (v <= 0) {
        callback(new Error('不能为0'))
      }
      callback()
    }
    const unitPriceRules = (rule, value, callback) => {
      let v = this.taskInfo[rule.fullField]
      if (!testNum.test(v)) {
        let _v = Number(v)
        console.log(_v)
        if (!isNaN(_v)) {
          callback(new Error('最多支持两位小数'))
        } else {
          callback(new Error('请输入有效数字'))
        }
      }
      callback()
    }
    const endTimeRules = (rule, value, callback) => {
      let v = this.taskInfo.endTime
      if (!v) {
        callback(new Error('请选择结束时间'))
      }
      callback()
    }
    const startDateDisabled = {}
    startDateDisabled.disabledDate = function (time) {
      return time.getTime() + 24 * 3600 * 1000 < Date.now()
    }
    return {
      dialogVisible: false,
      dialogVisible1: false,
      startDateDisabled,
      loading1: false,
      proxyList: [],
      childVal: [],
      taskInfo: {
        taskName: '',
        agencyApproveFlag: 1
        // executionValidateTo: '',
        // executionQuantity: 0,
        // executionSingleAmount: 0,
        // executionDescription: ''
      },
      taskInfoRules: {
        taskName: [{ required: true, validator: taskNameRules, trigger: 'blur' }],
        requireCount: [
          {
            required: true,
            validator: requireCountRules,
            trigger: 'blur'
          }
        ],
        unitPrice: [
          {
            required: true,
            validator: unitPriceRules,
            trigger: 'blur'
          }
        ],
        endTime: [
          {
            required: true,
            validator: endTimeRules,
            trigger: 'blur'
          }
        ]
      },
      search_name: '',
      page: {
        total: 0, // 总页数
        pagerCount: 5,
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页显示多少条
        pageSizes: [5, 10, 20, 30, 50, 100]
      },
      data: [],
      option: {
        addBtn: false,
        menu: false,
        refreshBtn: false,
        columnBtn: false,
        index: true,
        indexLabel: '序号',
        selection: true,
        reserveSelection: true,
        align: 'center',
        menuAlign: 'center',
        column: [
          {
            label: '委托代理名称',
            prop: 'name',
            slot: true
          }
        ]
      }
    }
  },
  watch: {},
  computed: {
    money() {
      let { requireCount = 0, unitPrice = 0 } = this.taskInfo
      return (requireCount * 100 * unitPrice) / 100 || 0
    }
  },
  methods: {
    onLoad(type) {
      this.tableLoading = true
      const p = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        nameOrPhone: this.search_name
      }
      agencyListDl(p)
        .then(res => {
          console.log(res)
          this.page.total = res.data.data.total
          this.page.pageSize = res.data.data.size
          this.data = res.data.data.items
          this.tableLoading = false
          if (type == 'init') {
            this.$nextTick(function () {
              for (let idx = 0; idx < this.data.length; idx++) {
                if (this.data[idx].proxyId == Number(this.$route.query.proxyId)) {
                  this.$refs.crud.toggleRowSelection(this.data[idx], true)
                  return
                }
              }
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.tableLoading = false
        })
    },
    getRadio(val) {
      console.log(val)
    },
    //整理通讯录代理名称
    getProxylName(row) {
      if (row.belongsTo == 'personal') {
        if (row.contact) {
          return row.proxyName + '-' + row.contact.slice(0, 3) + '****' + row.contact.slice(-4)
        } else {
          return row.proxyName
        }
      } else if (row.belongsTo == 'company') {
        return row.proxyCompanyName
      }
    },
    searchName() {
      this.onLoad()
    },
    cancelClick() {
      console.log(1)
    },
    getChildData(data) {
      this.childVal = data
    },
    doneClick() {
      if (this.childVal.length == 0) {
        this.$message.warning('代理未勾选，请勾选后重试')
        return
      }
      this.loading1 = true
      let taskInfo = this.$refs.childTask.taskInfo
      let arr = [
        {
          vueComponent: taskInfo,
          validateArr: ['taskName', 'requireCount', 'unitPrice', 'endTime']
        }
      ]
      this.$refs.childTask.$refs.taskInfo.validate(valid => {
        if (valid) {
          let validFlag = true
          this.childVal.forEach(it => {
            if (it.settleMode === 3) {
              it.settleRule.tiers.forEach((itTiers, indexTiers, arrTiers) => {
                itTiers.quantityLowerBound =
                  indexTiers > 0 ? arrTiers[indexTiers - 1].quantityUpperBound : itTiers.quantityLowerBound
                if (itTiers.quantityUpperBound === undefined || itTiers.unitPriceYuan === undefined) {
                  validFlag = false
                }
              })
              if (it.settleRule.expectedQuantity === undefined) {
                validFlag = false
              }
            } else if (it.settleMode === 1 || it.settleMode === 2) {
              if (it.settleRule.expectedQuantity === undefined || it.settleRule.unitPriceYuan === undefined) {
                validFlag = false
              }
            }
          })

          if (!validFlag) {
            this.$message.error('请完善表单项')
            return
          }

          let p = []
          for (let index = 0; index < this.childVal.length; index++) {
            p.push({
              // taskName : taskInfo.executionName,
              // unitPrice : taskInfo.executionSingleAmount,
              // requireCount : taskInfo.executionQuantity,
              // endTime : taskInfo.executionValidateTo,
              relationId: this.childVal[index].relationId,
              agentTenantId: this.childVal[index].proxyId,
              agentName: this.childVal[index].agentName,
              agentType: this.childVal[index].belongsTo == 'personal' ? 0 : 1,
              phone: this.childVal[index].contact,
              // qualityControlStandard : taskInfo.qualityControlStandard,
              // settleStandard : taskInfo.settleStandard,

              // executionRequirement: taskInfo.executionRequirement,
              // description:taskInfo.executionDescription,
              // surveyId : GlobalConfig.getSurveyId(),
              settleMode: this.childVal[index].settleMode,
              settleRule: this.childVal[index].settleRule,
              agentTenantId: this.childVal[index].agentTenantId
            })
          }
          const postData = {
            taskName: taskInfo.executionName,
            endTime: taskInfo.executionValidateTo,
            description: taskInfo.executionDescription,
            executionRequirement: taskInfo.executionRequirement,
            qualityControlStandard: taskInfo.qualityControlStandard,
            agencyApproveFlag: taskInfo.flag ? 1 : 0,
            surveyId: GlobalConfig.getSurveyId(),
            settleStandard: taskInfo.settleStandard,
            userList: p
          }

          addList(postData)
            .then(res => {
              if (res.data.code != 0) {
                this.$message.error(res.data.msg)
                return
              } else {
                // this.$message.success('代理添加成功');
                this.$alert('您已发布任务,等待代理承接任务', '已发布代理任务', {
                  confirmButtonText: '我知道了',
                  callback: action => {
                    this.$emit('cancel')
                  }
                })
              }
              // this.$emit('cancel')
              // this.$router.push({path:`/survey/${GlobalConfig.getSurveyId()}/agency/agency-interview/index`})
            })
            .catch(err => {
              console.log(err)
              this.dialogVisible1 = false
              this.$message.warning(err.message)
            })
        } else {
          this.loading1 = false
          console.log('error submit!!')
          this.dialogVisible1 = false
          return false
        }
      })
    },
    onClickSubmit() {
      this.dialogVisible1 = true
    }
  },
  created() {
    //this.onLoad();
  },
  mounted() {
    // this.onLoad('init');
  }
}
</script>
<style lang="scss" scoped>
.el-tag,
.el-tag--medium,
.el-tag--light {
  display: none;
}
.btn-footer {
  @apply h-16 flex items-center justify-end pr-6;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
